import { connect } from 'react-redux'
import Component from './Component'

import componentWillMount from './Handlers/componentWillMount'

const mapStateToProps = (state) => ({
  fetching: state.screens.ProjectView.fetching,
})

const actionCreators = {
  componentWillMount,
}

export default connect(mapStateToProps, actionCreators)(Component)
